import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["navigationGroups", "highlightedContent", "index", "prevNavigation", "nextNavigation"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Heading, Link, Box } from '@miro-site/core';
import Grid from './Grid';
import SecondaryNavigationItem from './SecondaryNavigationItem';
import styled, { useTheme } from 'styled-components';
import HeaderContainer from './HeaderContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ViewAllLink = styled(Link).attrs(function (_ref) {
  var theme = _ref.theme;
  return {
    $mt: theme.header.secondaryNavigation.viewAllLink.marginTop,
    $variant: theme.header.secondaryNavigation.viewAllLink.variant,
    $color: theme.header.secondaryNavigation.viewAllLink.color,
    withArrow: theme.header.secondaryNavigation.viewAllLink.withArrow,
    $styles: {
      fontSize: theme.header.secondaryNavigation.viewAllLink.fontSize,
      lineHeight: theme.header.secondaryNavigation.viewAllLink.lineHeight
    }
  };
}).withConfig({
  displayName: "SecondaryNavigation__ViewAllLink",
  componentId: "sc-15kqgii-0"
})([""]);
var SecondaryNavigationWrapper = styled(Box).attrs(function (_ref2) {
  var $isFixed = _ref2.$isFixed,
      $isExpanded = _ref2.$isExpanded,
      header = _ref2.theme.header;
  var expandedStyles = {
    pointerEvents: 'all',
    visibility: 'visible'
  };
  var collapsedStyles = {
    pointerEvents: 'none',
    visibility: 'hidden'
  };
  return {
    $py: header.secondaryNavigation.verticalPadding,
    $styles: _objectSpread({
      position: 'absolute',
      zIndex: 8,
      left: 0,
      top: header.height,
      width: '100%',
      maxHeight: "calc(100vh - ".concat(header.bottomLinks.height + header.height, "px)"),
      overflow: 'auto'
    }, $isExpanded ? expandedStyles : collapsedStyles)
  };
}).withConfig({
  displayName: "SecondaryNavigation__SecondaryNavigationWrapper",
  componentId: "sc-15kqgii-1"
})([""]);

var columnStyles = function columnStyles(theme, isExpanded, index, nextNavigation) {
  var translateOffset = theme.header.secondaryNavigation.animation.translateOffset;
  var styles = {
    background: theme.header.secondaryNavigation.background,
    transition: theme.header.secondaryNavigation.animation.columns
  };

  if (isExpanded) {
    return _objectSpread({
      opacity: 1,
      transform: 'translate(0, 0)'
    }, styles);
  }

  if (nextNavigation === null) {
    return _objectSpread({
      opacity: 0,
      transform: "translateY(-".concat(translateOffset, "px)")
    }, styles);
  }

  return _objectSpread({
    opacity: 0,
    transform: index > nextNavigation ? "translateX(".concat(translateOffset, "px)") : "translateX(-".concat(translateOffset, "px)")
  }, styles);
};

var AnimatedColumn = styled(Grid.Column).withConfig({
  displayName: "SecondaryNavigation__AnimatedColumn",
  componentId: "sc-15kqgii-2"
})(["", ""], function (_ref3) {
  var theme = _ref3.theme,
      $index = _ref3.$index,
      $isExpanded = _ref3.$isExpanded,
      $nextNavigation = _ref3.$nextNavigation;
  return theme.normalizeStyles(columnStyles(theme, $isExpanded, $index, $nextNavigation));
});
var NavigationColumn = styled(AnimatedColumn).withConfig({
  displayName: "SecondaryNavigation__NavigationColumn",
  componentId: "sc-15kqgii-3"
})(["transition-delay:", ";"], function (props) {
  return props.$isExpanded && props.$prevNavigation === null ? props.theme.header.secondaryNavigation.animation.navigationDelay : '0ms';
});
var HighlightedColumn = styled(AnimatedColumn).withConfig({
  displayName: "SecondaryNavigation__HighlightedColumn",
  componentId: "sc-15kqgii-4"
})(["transition-delay:", ";"], function (props) {
  return props.$isExpanded && props.$prevNavigation === null ? props.theme.header.secondaryNavigation.animation.highlightedDelay : '0ms';
});
var Headline = styled(Heading).attrs(function (_ref4) {
  var theme = _ref4.theme;
  return {
    as: theme.header.secondaryNavigation.headline.as,
    $my: theme.header.secondaryNavigation.headline.verticalMargin,
    $variant: theme.header.secondaryNavigation.headline.variant
  };
}).withConfig({
  displayName: "SecondaryNavigation__Headline",
  componentId: "sc-15kqgii-5"
})([""]);
var SecondaryNavigation = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var navigationGroups = props.navigationGroups,
      highlightedContent = props.highlightedContent,
      index = props.index,
      prevNavigation = props.prevNavigation,
      nextNavigation = props.nextNavigation,
      restProps = _objectWithoutProperties(props, _excluded);

  var theme = useTheme();
  var navigationGrid = navigationGroups.length < 3 || highlightedContent ? [null, null, 4, 8, 12] : [null, null, 6, 12, 18];
  var navigationGroupGrid = !highlightedContent && navigationGroups.length > 2 ? [null, null, 2, 4, 6] : navigationGrid.map(function (c) {
    if (c === null) {
      return null;
    }

    return navigationGroups.length > 1 ? c / 2 : c;
  });
  var navigationItemsGrid = [null, null, 1, 2, 3];
  var highlightedContentGrid = [null, null, 2, 4, 6];
  var isExpanded = index === nextNavigation;
  return /*#__PURE__*/_jsx(SecondaryNavigationWrapper, _objectSpread(_objectSpread({}, restProps), {}, {
    "aria-hidden": !isExpanded,
    ref: ref,
    $index: index,
    $prevNavigation: prevNavigation,
    $nextNavigation: nextNavigation,
    $isExpanded: isExpanded,
    children: /*#__PURE__*/_jsx(HeaderContainer, {
      children: /*#__PURE__*/_jsxs(Grid, {
        gutter: theme.header.grid.gutter,
        columns: theme.header.grid.columns,
        children: [/*#__PURE__*/_jsx(NavigationColumn, {
          $index: index,
          $prevNavigation: prevNavigation,
          $nextNavigation: nextNavigation,
          $isExpanded: isExpanded,
          columns: navigationGrid,
          children: /*#__PURE__*/_jsx(Grid, {
            gutter: theme.header.grid.gutter,
            columns: navigationGrid,
            children: navigationGroups.map(function (n) {
              return /*#__PURE__*/_jsxs(Grid.Column, {
                columns: navigationGroupGrid,
                children: [/*#__PURE__*/_jsx(Headline, {
                  children: n.title
                }), /*#__PURE__*/_jsx(Grid, {
                  as: "ul",
                  gutter: theme.header.grid.gutter,
                  columns: navigationGroupGrid,
                  children: n.items.map(function (i) {
                    return /*#__PURE__*/_jsx(Grid.Column, {
                      as: "li",
                      columns: navigationItemsGrid,
                      children: /*#__PURE__*/_jsx(SecondaryNavigationItem, {
                        path: i.path,
                        title: i.title,
                        description: i.description
                      }, i.title)
                    }, i.title);
                  })
                }), n.viewAllLink && /*#__PURE__*/_jsx(ViewAllLink, {
                  href: n.viewAllLink.path,
                  children: n.viewAllLink.title
                })]
              }, n.title);
            })
          })
        }), highlightedContent && /*#__PURE__*/_jsx(HighlightedColumn, {
          $index: index,
          $prevNavigation: prevNavigation,
          $nextNavigation: nextNavigation,
          $isExpanded: isExpanded,
          columns: highlightedContentGrid,
          children: highlightedContent
        })]
      })
    })
  }));
});
SecondaryNavigation.displayName = 'SecondaryNavigation';
export default SecondaryNavigation;